export default {
  guests_pay: 'Gli ospiti pagano {{amount}} al checkout (ultimo tasso di cambio).',
  missing_rate: 'Nessun tasso di cambio per {{currency}} ancora, quindi gli ospiti pagano {{amount}} non convertito.',
};
